// Single source of truth for company facts used on /press and /brand.
export const company = {
  legalName: 'Katlacode ehf',
  brandName: 'KatlaCode',
  founded: '2024',
  location: 'Reykjavík, Iceland',
  email: 'info@katlacode.ai',
  website: 'https://katlacode.ai',
  oneLiner: 'Clinical coding infrastructure, built inside hospitals.',
  boilerplateShort:
    'KatlaCode builds AI clinical-coding infrastructure inside hospitals. Its system reads physician notes and suggests the right diagnosis codes, working inside the hospital’s own record system.',
  boilerplateLong:
    'KatlaCode builds AI clinical-coding infrastructure inside hospitals. Its system reads physician notes as they are written and suggests the right diagnosis codes, so clinical documentation is coded correctly at the source instead of reconstructed afterwards. The company was founded in Reykjavík by a team spanning clinical practice, healthcare innovation, and applied AI research, and develops its products in collaboration with Landspítali University Hospital. KatlaCode is backed by the Technology Development Fund (Rannís), which supports its AI Discharge Copilot for physicians.',
  facts: [
    { label: 'Company', value: 'Katlacode ehf' },
    { label: 'Founded', value: '2024' },
    { label: 'Headquarters', value: 'Reykjavík, Iceland' },
    { label: 'Focus', value: 'AI clinical coding · discharge documentation' },
    { label: 'Working with', value: 'Landspítali University Hospital' },
    { label: 'Backed by', value: 'Technology Development Fund (Rannís)' },
    { label: 'Press contact', value: 'info@katlacode.ai' },
  ],
} as const;
